import * as React from 'react'

import { cn } from 'utils/cn'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const common =
  'py-3 px-4 w-full' +
  ' border border-input focus:border-input ' +
  'rounded-md ' +
  'focus-visible:ring-2 focus-visible:ring-offset-1 focus:ring-slate-300  focus:outline-none ' +
  'disabled:bg-gray-100 placeholder:text-gray-400'

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return <input type={type} className={cn(common, className)} ref={ref} {...props} data-1p-ignore />
})
Input.displayName = 'Input'

export type TextareaInputProps = React.InputHTMLAttributes<HTMLTextAreaElement>
const TextAreaInput = React.forwardRef<HTMLTextAreaElement, TextareaInputProps>(
  ({ className, type, ...props }, ref) => {
    return <textarea className={cn('h-40', common, className)} ref={ref} {...props} />
  }
)
TextAreaInput.displayName = 'TextareaInput'

export { Input, TextAreaInput }
